// src/context/PurchaseOrdersContext.jsx
import React, { createContext, useContext, useState, useEffect } from "react";
import { API_URL } from "../config";

const PurchaseOrdersContext = createContext();

export const usePurchaseOrders = () => useContext(PurchaseOrdersContext);

export const PurchaseOrdersProvider = ({ children }) => {
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPOs = async () => {
      try {
        const userId = localStorage.getItem("userId");
        const res = await fetch(
          `${API_URL}/api/purchaseorders/get?userId=${userId}`,
          {
            credentials: "include",
          }
        );
        const data = await res.json();
        if (data.success) setPurchaseOrders(data.data || []);
      } catch (err) {
        console.error("Failed to load POs", err);
      } finally {
        setLoading(false);
      }
    };
    fetchPOs();
  }, []);

  const addPurchaseOrder = (po) => {
    setPurchaseOrders((prev) => [po, ...prev]);
  };

  return (
    <PurchaseOrdersContext.Provider
      value={{ purchaseOrders, loading, addPurchaseOrder }}
    >
      {children}
    </PurchaseOrdersContext.Provider>
  );
};
